<template>
    <div>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="set-value-modal-label">Duplikat Data</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form method="get" :action="url">
                    <div class="modal-body">
                        <div class="row">
                            <div class="form-group col-md-6 mb-0">
                                <label for="from_year">Dari Tahun</label>
                                <input type="number" name="from_year" readonly required class="form-control year-datepicker" />
                            </div>
                            <div class="form-group col-md-6 mb-0">
                                <label for="from_year">Untuk Tahun</label>
                                <input type="number" name="to_year" readonly required class="form-control year-datepicker" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12 d-flex">
                            <div class="flex-column justify-content-end">
                                <button type="submit" class="btn btn-primary"><i class="la la-copy"></i>&nbsp;Proses</button>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Tutup</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DuplicateTemplateForm',
        props: {
            url: {
                type: String,
                default: () => (null)
            }
        }
    }
</script>
